import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Holds a pending Power BI report ID when the app is opened via a deep link
 * (e.g. ?reportId=xxx from a Power BI button Web URL). MisReportComponent
 * consumes this after loading embed configs and shows that report first.
 *
 * URL format for Power BI buttons: https://<app-base>/?reportId=<power-bi-report-id>
 */
@Injectable({
  providedIn: 'root'
})
export class ReportNavigationService {
  private readonly pendingReportId$ = new BehaviorSubject<string | null>(null);

  setPendingReportId(reportId: string | null): void {
    this.pendingReportId$.next(reportId);
  }

  getPendingReportId(): string | null {
    return this.pendingReportId$.getValue();
  }

  getPendingReportId$(): Observable<string | null> {
    return this.pendingReportId$.asObservable();
  }

  clearPendingReportId(): void {
    this.pendingReportId$.next(null);
  }
}
